export default "__VITE_ASSET__CAIJcEns__"